import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const sendConfirmationCode = asyncThunkWrapper({ 
  model: 'confirmations', 
  action: 'sendConfirmationCode', 
  func: async ({ email, password }) => {
    const response = await axios.post('/confirmations/two_factor', { email, password });

    return response.status;
  } 
});